import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 天澄分摊接口
 **********************************************************************************/
export default {
    /**
     * 分摊项目列表
     * @param {int} type 1,//分摊类型:1==空调;2==公共内部;3==公用外部
     */
    divideItemList: (type, success, failure) => {
        var p = {};
        if (type != 0) {
            p = {
                type
            };
        }
        //console.log("/tiancheng/shateDetailList:" + JSON.stringify(p));
        Axios.post('/tiancheng/shateDetailList', {
            type
        }, success, failure);
    },
    /**
     * 新增分摊项目
     * @param  "id": "",//主键id，更新时传入
     * @param  "name": "空调公摊1",//名称
     * @param  "type": 1,//分摊类型:1==空调;2==公共内部;3==公用外部
     * @param  "oneDeviceNos": [1, 2, 3, 4],//虚拟内机设备名称/电梯/照明
     * @param  "twoDeviceNos": [1, 2, 3]//虚拟外机设备名称//type==1时必传
     */
    addDivideItem: (id, name, type,twoDeviceNos,oneDeviceNos , success, failure) => {
        var p = {
            id,
            name,
            type,
            twoDeviceNos,
            oneDeviceNos
        };
        if (id.length > 0) {
            p['id'] = id;
        }
        Axios.post('/tiancheng/addShareDetail', {
            p
        }, success, failure);
    },
    /**
     * 删除分摊项目
     * @param {int} id 1
     */
    delDivideItem: (id, success, failure) => {
        var p = {
            id
        };
        Axios.post('/tiancheng/delShateDetail', {
            id
        }, success, failure);
    },
    /**
     * 用户分摊列表
     * 
     * "pageIndex": 0,//页码
     * "pageSize": 100,//每页条数
     * "startTime": "",//开始时间 2020-09-02 15:42
     * "endTime": "",//结束时间 2020-09-02 15:42
     * "userName": ""//业主名称、用户名称
     * 
     */
    divideFeeList: (userName, pageIndex, pageSize, startTime, endTime, success, failure) => {
        var p = {
            userName,
            startTime,
            endTime,
            pageSize,
            pageIndex
        };
        Axios.post('/tiancheng/userShareList', {
            p
        }, success, failure);
    },
    /**
     * 用户分摊统计
     * {
     * "pageIndex": 0,//页码
     * "pageSize": 100,//每页条数
     * "startTime": "",//开始时间 2020-09-02 15:42
     * "endTime": "",//结束时间 2020-09-02 15:42
     * "userName": ""//业主名称、用户名称
     * }
     */
    divideFeeSummary: (userName, pageIndex, pageSize, startTime, endTime, success, failure) => {
        var p = {
            userName,
            startTime,
            endTime,
            pageSize,
            pageIndex
        };
        Axios.post('/tiancheng/userShareAcount', {
            p
        }, success, failure);
    },
    /**
     * 用户分摊项目列表
     * userId
     */
    userDivideItemList: (userId, success, failure) => {
        var p = {
            userId
        };
        Axios.post('/tiancheng/getUserShareRelation', {
            userId
        }, success, failure);
    },
    /**
     * 用户分摊费用柱状图
     * userId	是	String	用户id、业主Id
     * type	是	int	1空调；2==室内公共分摊；3==室外公共分摊
     * time	是	Long	开始时间（时间戳毫秒）
     * endTime	是	Long	结束时间
     * dateType	是	String	查询周期：day, week, month, quarter, year, custom
     */
    userDivideFeeChart: (userId, type, time, endTime, dateType, success, failure) => {
        var p = {
            userId,
            type,
            time,
            endTime,
            dateType,
        };
        Axios.post('/history/userShareGetHistoryDifferenceRanking', {
            userId,
            type,
            time,
            endTime,
            dateType
        }, success, failure);
    },
}